import React from "react";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";

// Components
import Menu from "../components/Menu";
import Search from "../components/Search";
import Content from "../components/Content";
import ManageProduct from "../components/ManageProduct";
import AddProducts from "../components/AddProducts";
import Orders from "../comp-dashboard/orders";
import CustomTabPanel from "../components/CustomTabPanel";
import Products from "../comp-dashboard/products";
// CSS
import "../style/dashboard.css";

export default function nnnnnnnnnnn() {
  const [value, setValue] = useState(0);
  const handleTabValue = (valueFromChild) => {
    setValue(valueFromChild); // 👈 Receive the value
  };
  return (
    <div className="Dashboard">
      <Search />
      <div className="horizontal-grid">
        <Menu sendDatatoDash={handleTabValue} />
        {/* <AddProducts /> */}
        <Box sx={{ width: "100%" }}>
          {" "}
          <CustomTabPanel value={value} index={0}>
            {" "}
            <Orders />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            {" "}
            <Products />
          </CustomTabPanel>
        </Box>
      </div>
    </div>
  );
}
